export const LicenseTypes = {
    g: 'G',
    gOne: 'G1',
    gTwo: 'G2'
}
